import { tv } from 'tailwind-variants';

import { createInlineTextComponent, type InlineTextProps } from './utils';

const overlineVariants = tv({
    base: 'font-kalshi-sans',
    variants: {
        size: {
            x10: 'typ-overline-x10',
            x20: 'typ-overline-x20',
        },
        medium: {
            true: 'font-medium',
        },
        semibold: {
            true: 'font-semibold',
        },
        tabularNums: {
            true: 'typ-tabular',
        },
        underline: {
            true: 'underline-link',
        },
    },
});

/**
 * Overline Components
 *
 * All-caps label text for categorization and tagging.
 * Uses KalshiSans Semibold font with wide letter-spacing.
 *
 * @example
 * <Overline.x10>Politics</Overline.x10>
 * <Overline.x20>Featured Markets</Overline.x20>
 */
export const Overline = {
    /** Overline x10 - 11px/18px, KalshiSans Semibold, uppercase */
    x10: createInlineTextComponent(overlineVariants, 'Overline.x10', 'x10'),
    /** Overline x20 - 13px/20px, KalshiSans Semibold, uppercase */
    x20: createInlineTextComponent(overlineVariants, 'Overline.x20', 'x20'),
} as const;

export default Overline;
export { overlineVariants };
export type OverlineProps = InlineTextProps;
